/* eslint-disable react/require-default-props */
import React from 'react';
import Tooltip from '@carvana/showroom-tooltip';
import { Direction } from '@carvana/showroom-tooltip/types';
import { DisplayConfiguration } from '@carvana/showroom-tooltip/Base/Content';
import ToolTipIcon from '../../../assets/tool-tip-icon';
import { InfoToolTipWrapper } from './InfoToolTip.styles';
import { useDualEventTracking } from '../../../utils/useDualEventTracking';

const InfoToolTip = (props: {
  showArrow?: boolean;
  direction?: Direction;
  persist?: boolean;
  underline?: boolean;
  display?: Partial<DisplayConfiguration>;
  content: any;
  trackEventContent?: any;
}) => {
  const {
    showArrow,
    direction,
    persist,
    underline,
    display,
    content,
    trackEventContent,
  } = props;
  const { trackEvent } = useDualEventTracking();

  return (
    <InfoToolTipWrapper onMouseEnter={() => trackEvent(trackEventContent)}>
      <Tooltip
        content={content}
        showArrow={showArrow}
        direction={direction}
        persist={persist}
        underline={underline}
        display={display}
      >
        <ToolTipIcon
          onClick={(e: any) => e.stopPropagation()}
          aria-label="Info Circle Icon"
        />
      </Tooltip>
    </InfoToolTipWrapper>
  );
};

export default InfoToolTip;
